import { defaultTo, evolve, keys, pick, T as truth } from "ramda"
import { put, takeLatest } from "@redux-saga/core/effects"

import { Actions, Atom, Data, Namespace } from "@cirrus/fe-lib"
import { Theme } from "@cirrus/ui-kit"

import { Skins } from "../_params.js"
import { actions as dataActions } from "./data.js"

export const domain = Namespace.domain(Skins, "theme")

const initialState = {
  initialized: false,
  palette: {},
  skinObject: {},
  typography: {},
}

export const actions = Actions.of(Skins.domain, ["themeRequested", "themeGenerated"])

export const atom = Atom.behavior((on) => {
  on(actions.themeRequested, (state, payload) =>
    Theme.from(
      Data.merged(
        evolve({ initialized: truth }, state),
        evolve({ skinObject: defaultTo({}) }, pick(keys(initialState), payload)),
      ),
    ),
  )
}, initialState)

export const effects = [
  takeLatest(dataActions.dataObtained, function* ({ payload }) {
    yield put(actions.themeRequested(payload))
  }),
]
